import { Cell } from '../ultis/types';

export interface CartItem {
  cell: Cell;
  addedAt: number; // timestamp
}

const CART_STORAGE_KEY = 'vn-pixel-myCart';

class CartService {
  /**
   * Get all items in cart from localStorage
   */
  getCart(): CartItem[] {
    try {
      const cartJson = localStorage.getItem(CART_STORAGE_KEY);
      if (cartJson) {
        return JSON.parse(cartJson);
      }
    } catch (error) {
      console.error('Error reading cart from localStorage:', error);
    }
    return [];
  }

  /**
   * Add a cell to cart
   */
  addToCart(cell: Cell): boolean {
    try {
      const cart = this.getCart();
      
      // Check if cell already exists in cart (by cell index i)
      if (cell.i !== undefined && cart.some(item => item.cell.i === cell.i)) {
        console.log(`Cell ${cell.i} already in cart`);
        return false;
      }

      const newItem: CartItem = {
        cell,
        addedAt: Date.now(),
      };

      cart.push(newItem);
      localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(cart));
      
      // Dispatch event để các component khác có thể listen
      window.dispatchEvent(new CustomEvent('cart-updated', { 
        detail: { cart } 
      }));
      
      return true;
    } catch (error) {
      console.error('Error adding to cart:', error);
      return false;
    }
  }

  /**
   * Remove a cell from cart by cell index
   */
  removeFromCart(cellIndex: number): boolean {
    try {
      const cart = this.getCart();
      const filteredCart = cart.filter(item => item.cell.i !== cellIndex);
      
      if (filteredCart.length === cart.length) {
        return false; // Item not found
      }

      localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(filteredCart));
      
      // Dispatch event
      window.dispatchEvent(new CustomEvent('cart-updated', { 
        detail: { cart: filteredCart } 
      }));
      
      return true;
    } catch (error) {
      console.error('Error removing from cart:', error);
      return false;
    }
  }

  /**
   * Clear all items from cart
   */
  clearCart(): void {
    try {
      localStorage.removeItem(CART_STORAGE_KEY);
      
      // Dispatch event
      window.dispatchEvent(new CustomEvent('cart-updated', { 
        detail: { cart: [] } 
      }));
    } catch (error) {
      console.error('Error clearing cart:', error);
    }
  }

  /**
   * Get cart item count
   */
  getCartCount(): number {
    return this.getCart().length;
  }

  /**
   * Check if a cell is already in cart
   */
  isInCart(cellIndex: number): boolean {
    const cart = this.getCart();
    return cart.some(item => item.cell.i === cellIndex);
  }
}

export const cartService = new CartService();
export default cartService;


